import request from '@/utils/request'
import { needsInviteCodePending } from '@/utils/common'

const INTERVAL_MS = 30 * 1000

let timer = null
let inFlight = false

function hasToken() {
  return !!localStorage.getItem('token')
}

async function pingUserStatus() {
  if (!hasToken()) {
    stopUserStatusPolling()
    return
  }
  // 邀请码未完成前不检测账号状态，避免新用户误报封禁
  if (needsInviteCodePending()) {
    return
  }
  if (inFlight) return

  inFlight = true
  try {
    await request.post('/api/get_user_status', {})
  } catch (err) {
    // Login required / account_disabled handled in request interceptor
    if (process.env.NODE_ENV === 'development') {
      console.log('user status heartbeat failed', err?.info || err?.message || err)
    }
  } finally {
    inFlight = false
  }
}

export function startUserStatusPolling() {
  if (!hasToken()) return
  if (needsInviteCodePending()) return
  if (timer) return

  pingUserStatus()
  timer = setInterval(pingUserStatus, INTERVAL_MS)
}

export function stopUserStatusPolling() {
  if (timer) {
    clearInterval(timer)
    timer = null
  }
}
